export const selectTheme = {
    colors: {
        danger: "var(--cl-main-dark)",
        dangerLight: "var(--cl-main-light-1)",
        neutral0: "var(--color-third)",
        neutral10: "var(--color-fourth-transparent)",
        neutral20: "var( --color-first-dark )", //the outline
        neutral30: "var(--color-fourth-transparent)",
        neutral40: "var(--color-fourth-transparent)",
        neutral5: "var(--color-fourth-transparent)",
        neutral50: "var( --color-first )",
        neutral60: "var( --color-first )",
        neutral70: "var( --color-first )",
        neutral80: "black",
        neutral90: "black",
        primary: "var(--color-first)",
        primary25: "var(--color-fourth-transparent)",
        primary50: "var(--color-fourth-transparent)",
        primary75: "var(--color-fourth-transparent)",
    },
    borderRadius: 4,
    spacing: {
        baseUnit: 5,
        controlHeight: 3,
        menuGutter: 2,
    },
};
